import { Component, OnInit, DestroyRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { StatComponent } from '@app/shared/modules/stat/stat.component';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-dashboard-cards',
  templateUrl: './dashboard-cards.component.html',
  styleUrls: ['./dashboard-cards.component.scss'],
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, StatComponent]
})
export class DashboardcardsComponent implements OnInit {
  dataLoaded: boolean;
  cards = [
    {
      label: { firstLine: 'cards.districts.firstLine', secondLine: 'cards.districts.secondLine' },
      icon: 'beach-house',
      to: 'reports/districts',
      count: 0
    },
    {
      label: { firstLine: 'cards.weight.firstLine', secondLine: 'cards.weight.secondLine' },
      icon: 'weight',
      to: 'reports/per-hour',
      firstLine: '',
      secondLine: '',
      count: 0
    },
    {
      label: { firstLine: 'cards.units.firstLine', secondLine: 'cards.units.secondLine' },
      icon: 'delivery-truck-with-circular-clock',
      to: 'reports/units',
      firstLine: '',
      secondLine: '',
      count: 0
    },
    {
      label: { firstLine: 'cards.contractors.firstLine', secondLine: 'cards.contractors.secondLine' },
      icon: 'businessman',
      to: 'reports/contractors',
      firstLine: '',
      secondLine: '',
      count: 0
    },
    {
      label: { firstLine: 'cards.waste_type.firstLine', secondLine: 'cards.waste_type.secondLine' },
      icon: 'recycle-bin',
      to: 'reports/waste-types',
      firstLine: '',
      secondLine: '',
      count: 0
    }
  ];

  constructor(
    private router: Router,
    private ar: ActivatedRoute,
    private service: DashboardService,
    private toArabic: ToArabicPipe,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.service
      .getData('total-yesterday-info')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((data: any) => {
          for (const key in data.data) {
            data.data[key] = this.toArabic.transform(data.data[key].toString());
          }
          return data.data;
        })
      )
      .subscribe((response: any) => {
        this.cards[0]['count'] = response['districts_count'];
        this.cards[1]['count'] = response['total_weights'];
        this.cards[2]['count'] = response['units_count'];
        this.cards[3]['count'] = response['contractors_count'];
        this.cards[4]['count'] = response['waste_types_count'];
        this.dataLoaded = true;
      });
  }

  goTo(url: string) {
    this.router.navigate([url]);
  }
}
